import React from 'react';
import { historyDetailShape } from 'constants/propTypes';

import { ActionItemCustomer, ActionItemCustomerCell } from './HistoryDetail.styles';

const HistoryActionCustomer = ({ detail }) => {
  const { companyName, firstName, lastName, email, phoneNumber } = detail.data.customer;

  const getName = () => companyName || (firstName || lastName ? `${firstName ?? ''} ${lastName ?? ''}` : '-');

  return (
    <ActionItemCustomer>
      <ActionItemCustomerCell>{getName()}</ActionItemCustomerCell>
      <ActionItemCustomerCell>{email}</ActionItemCustomerCell>
      <ActionItemCustomerCell>{phoneNumber}</ActionItemCustomerCell>
    </ActionItemCustomer>
  );
};

HistoryActionCustomer.propTypes = {
  detail: historyDetailShape.isRequired
};

export default HistoryActionCustomer;
